import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAdminSetting } from "../../services/adminSettingApiFn";

// Async thunk to fetch setting data
export const fetchSettings = createAsyncThunk(
  "home/fetchSettings",
  async () => {
    const response = await getAdminSetting();
    return response.data.data;
  }
);

const initialState = {
  isLoading: false,
  settings: null,
  error: false,
};

// Product slice
const settingsSlice = createSlice({
  name: "settings",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchSettings.pending, (state) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(fetchSettings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.settings = action.payload;
      })
      .addCase(fetchSettings.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
      });
  },
});

export default settingsSlice.reducer;
